<template>
    <section class="workflow-section">
        <div class="workflow-container">
            <h2 class="section-title">Streamlined Workflows</h2>
            <p class="section-subtitle">Automate your asset management processes with customizable workflows that
                    increase efficiency and ensure compliance.</p>
                
            <!-- Asset Request Workflow -->
            <div class="workflow-card">
                <h3 class="workflow-title">Asset
                    Request Workflow</h3>

                <div class="workflow-step">
                    <!-- <div class="step-number">1</div> -->
                    <div class="step-number">
                        <svg viewBox="0 0 140 160" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="40" fill="#f3f4f6" />
                            <text x="50" y="60" font-family="Arial" font-size="35" font-weight="bold" text-anchor="middle" fill="#000">1</text>
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4 class="item-header">Request Submission</h4>
                        <p class="item-content">Employee submits an asset request with required details
                            and justification.</p>
                    </div>
                </div>

                <div class="workflow-step">
                    <div class="step-number">
                        <svg viewBox="0 0 140 160" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="40" fill="#f3f4f6" />
                            <text x="50" y="60" font-family="Arial" font-size="35" font-weight="bold" text-anchor="middle" fill="#000">2</text>
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4 class="item-header">Manager Review</h4>
                        <p class="item-content">Direct supervisor reviews request and adds departmental
                            approval.</p>
                    </div>
                </div>

                <div class="workflow-step">
                    <div class="step-number">
                        <svg viewBox="0 0 140 160" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="40" fill="#f3f4f6" />
                            <text x="50" y="60" font-family="Arial" font-size="35" font-weight="bold" text-anchor="middle" fill="#000">3</text>
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4 class="item-header">Inventory Check</h4>
                        <p class="item-content">System automatically checks inventory availability and
                            budget allocation.</p>
                    </div>
                </div>

                <div class="workflow-step">
                    <div class="step-number">
                        <svg viewBox="0 0 140 160" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="40" fill="#f3f4f6" />
                            <text x="50" y="60" font-family="Arial" font-size="35" font-weight="bold" text-anchor="middle" fill="#000">4</text>
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4 class="item-header">Final Approval</h4>
                        <p class="item-content">IT/Asset Management team gives final approval and
                            assigns asset.</p>
                    </div>
                </div>

                <div class="workflow-step" style="display: flex; align-items: flex-start;">
                    <div class="step-number">
                        <svg viewBox="0 0 140 160" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="40" fill="#10b981" />
                            <text x="50" y="60" font-family="Arial" font-size="35" font-weight="bold" text-anchor="middle" fill="#000">✓</text>
                        </svg>
                    </div>
                    <!-- <div class="step-number success">✓</div> -->
                    <div>
                        <h4 class="item-header">Asset Assignment</h4>
                        <p class="item-content">Asset is assigned to employee with automatic record
                            update and notifications.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'WorkflowSection',
    data() {
        return {
        }
    }
}
</script>

<style scoped>
/* Layout Styles */
.workflow-section {
    background-color: #fff;
}

.workflow-container {
    max-width: 72rem;
    margin: 0 auto;
    padding: 64px 16px;
}

.section-title {
    font-size: 2rem;
    font-weight: bold;
    color: #1f2937;
    text-align: center;
}

.section-subtitle {
    font-size: 1.25rem;
    color: #4b5563;
    text-align: center;
    margin-bottom: 2rem;
}

.workflow-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    color: #000;
}

.workflow-card {
    flex: 1;
    min-width: 300px;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    /* gap: 2rem; 
    margin-top: 3rem; 
    flex-wrap: wrap; */
}

.workflow-card {
    flex: 1;
    min-width: 300px;
    max-width: 450px;
    margin: auto;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: left;
}

.workflow-step {
    display: flex;
    margin-bottom: 1.5rem;
    align-items: flex-start;
}

.step-number svg {
    width: 3rem;
    height: 3rem;
}

/* .step-number {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: #f3f4f6;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    margin-right: 1rem;
}

.step-number.success {
    background-color: #10b981;
} */

.step-content {
    border-bottom: 0.5px dashed #000;
    padding-bottom: 1rem;
}

.item-header {
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.item-content {
    color: #475569;
}
</style>